// This file is used for backward compatibility for old
// envs that directly reference this file.
// Please use the jest.cjs.config.js file instead.
// Please do not delete this file.
const cjsConfig = require('./jest.cjs.config');

module.exports = cjsConfig;
